import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { catalogErrorOf } from './catalog-text';

const SCOPE = 'compositeProducts';

/**
 * The messages of the catalog screens: the success of an action and the explanation of an error.
 * A business error of the backend is `570 {message: 'catalog.*', data}` and its text is `compositeProducts.errors.<message>`; anything else is the plain failure.
 */
@Injectable({providedIn: 'root'})
export class CatalogNotifyService {
  private readonly nz = inject(NzNotificationService);
  private readonly tr = inject(TranslocoService);

  success(key: string, params?: Record<string, unknown>): void {
    this.nz.success('', this.tr.translate(`${SCOPE}.${key}`, params));
  }

  error(err: unknown): void {
    this.nz.error('', this.errorText(err));
  }

  errorText(err: unknown): string {
    const error = catalogErrorOf(err);
    if (error?.key) {
      const key = `${SCOPE}.errors.${error.key}`;
      const text = this.tr.translate(key, error.data);
      if (text !== key) {
        return text;
      }
    }
    if (error?.status === 403) {
      return this.tr.translate(`${SCOPE}.errors.forbidden`);
    }
    return this.tr.translate(`${SCOPE}.errors.failed`);
  }
}
